import { AxiosRequestConfig } from 'axios';
import { Options, ProviderFn, ServerResponse } from 'services/api';

import buildApiUrl from '../utils/buildApiUrl';
import handleApiError from '../utils/handle-api-err';

export default class Base {
  protected _api_host: string;
  protected _api_version: number;
  protected _api_scope: string;
  protected _provider: ProviderFn;
  protected _full_url: boolean;

  protected readonly _request = {
    Get: 'GET',
    Post: 'POST',
    Put: 'PUT',
    Delete: 'DELETE',
    Patch: 'PATCH',
    Head: 'HEAD',
    Options: 'OPTIONS'
  };

  constructor(options: Options) {
    this._api_host = options.host;
    this._provider = options.provider;
    this._full_url = options.fullUrl || false;

    this._api_version = options.version || 5;
    this._api_scope = options.scope || 'corporate-api';
  }

  generateUrl(path: string) {
    const host = this._full_url ? this._api_host : undefined;
    return buildApiUrl(path, host, this._api_version, this._api_scope);
  }

  /**
   * Underlying use the provided provider to make request and handle error
   * @param {AxiosRequestConfig} config axios request config
   */
  async makeRequest<R extends ServerResponse, D = any>(
    config: AxiosRequestConfig<D>
  ) {
    try {
      const res = await this._provider<R, D>(config);
      return res.data;
    } catch (err) {
      throw handleApiError(err);
    }
  }
}
